import {
  ACCESS_CONTEXTS,
  HABITAT_FEATURES,
  emptyFishingSetting,
  normalizeFishingSetting,
} from "../fishingIntelligence/fishingSetting";

const FAVORITE_SPOT_KEY_PATTERN = /^-?\d+\.\d{6},-?\d+\.\d{6}$/;
const habitatFeatures = new Set(HABITAT_FEATURES);
const accessContexts = new Set(ACCESS_CONTEXTS);

const validSavedSetting = (value) => {
  if (value == null) return emptyFishingSetting();
  if (
    typeof value !== "object" ||
    value.version !== 1 ||
    value.source !== "user_confirmed" ||
    typeof value.confirmedAt !== "string" ||
    !value.confirmedAt.trim() ||
    !Array.isArray(value.habitatFeatures) ||
    value.habitatFeatures.some((feature) => !habitatFeatures.has(feature)) ||
    new Set(value.habitatFeatures).size !== value.habitatFeatures.length ||
    (value.accessContext !== null && !accessContexts.has(value.accessContext))
  ) {
    return emptyFishingSetting();
  }

  return normalizeFishingSetting(value);
};

export const createFavoriteSpotOutlookContext = (spot) => {
  if (
    !spot ||
    typeof spot.spotKey !== "string" ||
    !FAVORITE_SPOT_KEY_PATTERN.test(spot.spotKey) ||
    !Number.isFinite(spot.lat) ||
    !Number.isFinite(spot.lng) ||
    spot.lat < -90 ||
    spot.lat > 90 ||
    spot.lng < -180 ||
    spot.lng > 180
  ) {
    return null;
  }

  return {
    ...(["shore", "boat_kayak"].includes(spot.habitatContext?.platform)
      && spot.habitatContext?.version === 1 && spot.habitatContext?.source === "user_confirmed"
      ? { platform: spot.habitatContext.platform } : {}),
    spotKey: spot.spotKey,
    latitude: spot.lat,
    longitude: spot.lng,
    fishingSetting: validSavedSetting(spot.habitatContext),
  };
};

export const favoriteSpotMapEventDetail = (spot) => {
  const privateFavoriteOutlookContext = createFavoriteSpotOutlookContext(spot);
  return {
    lat: spot?.lat,
    lng: spot?.lng,
    name: spot?.name,
    openSpotWindow: Boolean(privateFavoriteOutlookContext),
    privateFavoriteOutlookContext,
  };
};
